import { removeUrlPrefix, urlPrefix } from '@gameday/common/functions'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import styled from 'styled-components'

// import bg from '@gameday/common/assets/images/bg.jpg'
import bg from '../../../../../assets/images/bg.jpg'
import CustomButton from '../Button'
import HeroDate from './HeroDate'

const heroBG = ''

const Wrapper = styled.main`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  padding: 30px;
  line-height: 1.1;
  color: var(--light-text);
  @media only screen and (min-width: 1440px) {
    min-height: 700px;
  }
  @media only screen and (max-width: 599px) {
    min-height: auto;
    padding: 100px 20px 40px;
  }
`

const Inner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
const Background = styled.div`
  position: absolute;
  background-image: ${props =>
    props.backgroundImage
      ? `${props.backgroundImage && `url(${props.backgroundImage}),`} linear-gradient(
      240deg,
      ${heroBG.concat(props.gradientOne)},
      ${heroBG.concat(props.gradientTwo)}
    )`
      : `linear-gradient(
      240deg,
      ${props.gradientOne},
      ${props.gradientTwo}
    )`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: -2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const Overlay = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: ${props => `linear-gradient(
      240deg,
      ${props.gradientOne},
      ${props.gradientTwo}
    )`};
  opacity: 0.9;
`

const Divider = styled.span`
  display: block;
  width: 1px;
  height: 120px;
  margin: 0 40px;
  background-color: var(--date-text);
  opacity: 0.6;
  @media only screen and (max-width: 600px) {
    width: 40px;
    height: 2px;
    margin: 10px 0;
  }
`

const Title = styled.h1`
  max-width: 540px;
  font-weight: 900;
  font-size: 52px;
  line-height: 1.2;
  margin: 0 0 20px 0;
  color: var(--light-text);
  @media only screen and (max-width: 720px) {
    font-size: 44px;
    margin: 10px 0;
  }
  @media only screen and (max-width: 600px) {
    font-size: 28px;
    margin: 10px 0;
  }
`

const Url = styled.a`
  display: block;
  margin-bottom: 20px;
  font-size: 26px;
  font-weight: 500;
  color: var(--light-text);
  text-decoration: none;
  &:hover {
    opacity: 0.5;
  }
  @media only screen and (max-width: 720px) {
    font-size: 20px;
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`

const Contact = styled.div`
  display: flex;
  font-weight: 500;
  opacity: 0.6;
  .pipe {
    margin: 0 10px;
  }
  a {
    color: var(--light-text);
    text-decoration: none;
    &:hover {
      opacity: 0.7;
    }
  }
  @media only screen and (max-width: 720px) {
    flex-direction: column;
    font-size: 14px;
    line-height: 1.5;
    .pipe {
      display: none;
    }
  }
  @media only screen and (max-width: 600px) {
    font-size: 12px;
  }
`

const Buttons = styled.div`
  display: flex;
  white-space: nowrap;
  margin-top: 20px;
  button:first-child {
    margin-right: 0.5em;
  }
`

const Hero = ({
  backgroundImage,
  buttonBGColor,
  buttonTextColor,
  dateEnd,
  dateStart,
  email,
  gradientOne,
  gradientTwo,
  phone,
  registerURL,
  timezone,
  title,
  url,
}) => {
  const scrollToKeyDetails = () => {
    const target = document.getElementById('map') || document.getElementById('key-details')
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }
  const websiteURL = url && urlPrefix(url)
  const prettyURL = url && removeUrlPrefix(url)

  return (
    <Wrapper>
      <Background backgroundImage={backgroundImage} gradientOne={gradientOne} gradientTwo={gradientTwo} />
      <Overlay gradientOne={gradientOne} gradientTwo={gradientTwo} />
      <Inner>
        <HeroDate dateStart={dateStart} dateEnd={dateEnd} timezone={timezone} />
        <Divider />
        <div>
          <Title>{title}</Title>
          {url && (
            <Url href={websiteURL} target="_blank" rel="noopener noreferrer">
              {prettyURL}
            </Url>
          )}
          <Contact>
            {phone && <span>{phone}</span>}
            {email && phone && <span className="pipe">|</span>}
            {email && <a href={`mailto:${email}`}>{email}</a>}
          </Contact>
          <Buttons>
            {registerURL && (
              <CustomButton
                background={buttonBGColor}
                color={buttonTextColor}
                onClick={() => {
                  window.open(registerURL, '_self')
                  // eslint-disable-next-line no-restricted-globals
                  location.reload()
                }}
                size="large"
              >
                Register Now
              </CustomButton>
            )}
            <CustomButton background={buttonTextColor} color={buttonBGColor} onClick={scrollToKeyDetails} size="large">
              Find this event <ArrowDownward />
            </CustomButton>
          </Buttons>
        </div>
      </Inner>
    </Wrapper>
  )
}

Hero.defaultProps = {
  backgroundImage: bg,
  buttonBGColor: '#FFFFFF',
  buttonTextColor: '#A53B32',
  email: '',
  gradientOne: '#f06d06',
  gradientTwo: '#A53B32',
  phone: '',
  url: '',
}

export default Hero
